import { render, staticRenderFns } from "./OddsHistory.vue?vue&type=template&id=31087af1&scoped=true"
import script from "./OddsHistory.vue?vue&type=script&lang=js"
export * from "./OddsHistory.vue?vue&type=script&lang=js"
import style0 from "./OddsHistory.vue?vue&type=style&index=0&id=31087af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31087af1",
  null
  
)

export default component.exports